import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieConsent from '../../components/feature/CookieConsent';
import HeroSection from './components/HeroSection';
import BiographySection from './components/BiographySection';
import FeaturesSection from './components/FeaturesSection';
import SolutionsSection from './components/SolutionsSection';
import BenefitsSection from './components/BenefitsSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://curtiswaters.ai';
    
    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "AI Solutions  | Deal Evaluation & Business Intelligence",
      "description": "AI solutions Charlotte NC. Expert deal evaluation & business intelligence. 25+ years experience, 100+ companies served. Reduce costs 40%, instant insights.",
      "url": siteUrl,
      "mainEntity": {
        "@type": "Person",
        "name": "Curtis Waters",
        "jobTitle": "AI Business Transformation Expert",
        "description": "With over 25 years of experience in business intelligence, Curtis Waters has helped more than 100 companies transform their operations.",
        "image": "https://static.readdy.ai/image/6d588a7c18ffff00d30b97de4504c2f6/a522a0f9274a957dc87b806e1f3025c8.png",
        "worksFor": {
          "@type": "Organization",
          "name": "Curtis Waters AI",
          "description": "AI platform that delivers instant business intelligence without complexity"
        },
        "knowsAbout": [
          "Artificial Intelligence",
          "Business Intelligence",
          "Business Transformation",
          "Data Analytics",
          "Process Automation",
          "Deal Evaluation",
          "Machine Learning",
          "Predictive Analytics"
        ]
      },
      "about": {
        "@type": "Service",
        "name": "AI Business Transformation",
        "description": "AI-powered deal and people evaluator empowering business decisions",
        "provider": {
          "@type": "Person",
          "name": "Curtis Waters"
        }
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl
          }
        ]
      }
    };

    // Remove existing schema script if any
    const existingScript = document.querySelector('script[data-schema="homepage"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new schema script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'homepage');
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      const schemaScript = document.querySelector('script[data-schema="homepage"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <BiographySection />
      <FeaturesSection />
      <SolutionsSection />
      <BenefitsSection />
      <ContactSection />
      <Footer />
      <CookieConsent />
    </div>
  );
}
